
import axios from 'axios'

/**
 * Service to call payment endpoints
 */
const PaymentService = {
  /**
   * post a payment
   * @param params
   * @returns {*}
   */
  post (params) {
    return new Promise((resolve, reject) => {
      axios
        .post('payments/make-payment', params)
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          if (error.response) {
            reject(error.response)
          } else {
            reject(new Error(error))
          }
        })
    })
  },

  confirm (params) {
    return new Promise((resolve, reject) => {
      axios
        .post('fmceb/bills/confirm-payment', params)
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          if (error.response) {
            reject(error.response)
          } else {
            reject(new Error(error))
          }
        })
    })
  },

  fund (params) {
    return new Promise((resolve, reject) => {
      axios
        .post('payments/fund-wallet', params)
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          if (error.response) {
            reject(error.response)
          } else {
            reject(new Error(error))
          }
        })
    })
  }
}

export default PaymentService



// WEBPACK FOOTER //
// ./src/services/payment.service.js